import { ERTNGridRowType } from './ertnGridRowAndColumnBuilder.utils';
import {
  AddErtnBatchPayload,
  ERTNBatchStatusTransformed,
  GetErtnByYearByStatusResponseTransformed,
  GetERTNByYearItem,
} from '@/ertn/services/ertnApi';

export function isValidSchoolYearForErtn(year: number) {
  if (year && !isNaN(year) && year < 2100 && year > 1900) {
    return true;
  }

  return false;
}

export function isValidBatchNameForErtn(batchName: string) {
  if (batchName && batchName.trim() !== '') {
    return true;
  }

  return false;
}

export function isValidPayloadForCreate(payload: AddErtnBatchPayload) {
  if (payload.ertnBatchName && payload.schoolYear && isValidSchoolYearForErtn(payload.schoolYear)) {
    return true;
  }

  return false;
}

export function getResultCounts(response: GetErtnByYearByStatusResponseTransformed | undefined) {
  let isEmpty = undefined;
  let total = undefined;

  if (response === undefined) {
    return {
      isEmpty,
      total,
    };
  }

  if (response.range && Array.isArray(response.range) && response.range.length === 3) {
    total = response.range[2];
  }

  if (response.ertns && Array.isArray(response.ertns) && response.ertns.length === 0) {
    isEmpty = true;
  }

  return {
    isEmpty,
    total,
  };
}

export function getComputedBatchStatus(ertn: GetERTNByYearItem): ERTNBatchStatusTransformed {
  if (ertn.status === 'A' || ertn.status === 'E') {
    return ertn.status;
  } else if (ertn.status === '' || ertn.status === null) {
    if (ertn.employeeCount <= 0) {
      return 'empty-batch';
    } else {
      return 'batch-with-employee';
    }
  }

  return 'Unknown';
}

export function isNewAndEmpty({ status, employees }: ERTNGridRowType) {
  return status === 'empty-batch' && employees <= 0;
}

export function isAccepted({ status }: ERTNGridRowType) {
  return status === 'A';
}
